import store from "../store"

const defaultState = {
    byIds: {},
    allIds: [],
    loading: false,
    error: undefined
} 

const authReducer = (state = defaultState, action) => {
    switch(action.type) {
        case "GET_FLOOR_TYPES_REQUEST": 
            return { ...state, loading: true }
        case "GET_FLOOR_TYPES_SUCCESS":
            let { floor_types } = action.payload.data
            for (let floor_type of floor_types) {
                state.byIds[floor_type.id] = floor_type
                if (state.allIds.indexOf(floor_type.id) === -1) state.allIds.push(floor_type.id);
            }
            return { ...state, error: undefined, loading: false, allIds: [ ...state.allIds ], byIds: { ...state.byIds } }
        case "GET_FLOOR_TYPES_FAILED":
            return { ...state, error: action.error, loading: false, allIds: [ ...state.allIds ], byIds: { ...state.byIds } }
        default:
            return state;
    }
}

export default authReducer;
